
import { defineComponent } from 'vue'

// paper information
interface PaperInfo {
  title: string,
  author: string,
  arxiv?: string,
  journal?: string,
  volume?: string,
  page?: string,
  year?: number,
  url?: string,
  note?: string,
  bibtex: string
}

export default defineComponent({
  data () {
    return {
      papers: [
        {
          title: 'Finite-Momentum Superconductivity in ‘Third-Type Magnets’: Toward Realization of the Superconducting Diode Effect',
          author: '<u>Shuntaro Sumita</u>',
          journal: 'JPSJ News and Comments',
          volume: '22',
          page: '08',
          year: 2025,
          url: 'https://journals.jps.jp/doi/10.7566/JPSJNC.22.08',
          note: '[a short review on <a href="https://journals.jps.jp/doi/full/10.7566/JPSJ.94.064705" target="_blank">J. Phys. Soc. Jpn. 94, 064705 (2025)</a>.]',
          bibtex:
          `@article{JPSJ.22.08,
  author = {Sumita, Shuntaro},
  title = {{Finite-Momentum Superconductivity in ‘Third-Type Magnets’: Toward Realization of the Superconducting Diode Effect}},
  journal = {JPSJ News and Comments},
  volume = {22},
  pages = {08},
  year = {2025},
  doi = {10.7566/JPSJNC.22.08}
  url = {https://journals.jps.jp/doi/10.7566/JPSJNC.22.08}
}`
        },
        {
          title: 'Topological gapless points in superconductors: From the viewpoint of symmetry',
          author: '<u>Shuntaro Sumita</u> and Youichi Yanase',
          arxiv: '2107.05801',
          journal: 'Prog. Theor. Exp. Phys.',
          volume: '2022',
          page: '04A102',
          year: 2022,
          url: 'https://doi.org/10.1093/ptep/ptab124',
          note: `[an invited review paper; <b><span class="text-success">Editor's Choice</span></b>.]<br/>
          <a href="https://doi.org/10.7566/JPSHT.1.068" target="_blank">JPS Hot Topics</a>で紹介されました．`,
          bibtex:
          `@article{ptep.2022.04A102,
  author = {Sumita, Shuntaro and Yanase, Youichi},
  title = {{Topological gapless points in superconductors: From the viewpoint of symmetry}},
  journal = {Progress of Theoretical and Experimental Physics},
  volume = {2022},
  number = {4},
  pages = {04A102},
  year = {2022},
  month = {10},
  issn = {2050-3911},
  doi = {10.1093/ptep/ptab124},
  url = {https://doi.org/10.1093/ptep/ptab124}
}`
        }
      ] as PaperInfo[]
    }
  }
})
